import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "wrapper-background"
};
const _hoisted_2 = {
  class: "g1g__cards_wrapper"
};
const _hoisted_3 = {
  class: "g1g__inlinecard"
};
const _hoisted_4 = {
  class: "inline__cards"
};
const _hoisted_5 = {
  class: "inline__card"
};
import { useRouter } from "vue-router";
import CloudinaryImage from "@/components/CloudinaryImage.vue";
import { track } from "@/analytics/events";
export default {
  __name: 'help',
  setup(__props) {
    const router = useRouter();
    const contactUsRedirect = () => {
      track(`Static Clickable`, {
        source: `Home page - Contact us`
      });
      router.push({
        path: "contact-us"
      });
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
        class: "card__content"
      }, [_cache[0] || (_cache[0] = _createElementVNode("h3", {
        class: "help-card-heading pt-2"
      }, " Get honest help from certified travel safety experts. ", -1)), _cache[1] || (_cache[1] = _createElementVNode("p", {
        class: "help-card-subheading"
      }, " Here to help. Not to sell. Show you the fine print. Even tell you when you do not need travel insurance. ", -1)), _createElementVNode("div", {
        class: "card_button mb-3"
      }, [_createElementVNode("a", {
        class: "btn-outline-primary",
        onClick: contactUsRedirect
      }, "Contact us")])]), _createVNode(CloudinaryImage, {
        alt: "Illustration of a travel expert and G1G's dog mascot ITIRA, ready to help",
        class: "card__img",
        imageName: "contact_ruvpgm"
      })])])])])]);
    };
  }
};